module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062568366_Contents#r_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You probably think dinosaurs are cool. I do too. But I prefer the ones that aren’t trying to crush me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The one in front of me looked kind of like a T. rex, except totally made of metal. Its head scraped the high ceiling of the grocery store as mechanical feet slammed down with enough force to crack the smooth floor.")]), _vm._v(" "), _c('p', {
    staticClass: "figbody"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Wishbreaker9_rev.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("Robo Rex paused, tilted its head, and let out a roar that sounded like nails in a blender. A row of multicolored LED lights flickered across its razor teeth, and both eyes flashed red and yellow. On a TV show, it would have looked ridiculously cheesy. But in real life it was really quite terrifying.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If it didn’t bite me in half, it would stomp me with those iron feet. At least it had tiny, useless arms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lasers suddenly shot from Robo Rex’s arms, blasting another shelf to bits. Okay, not so useless after all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was time to find Ridge and take this punk down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grabbed one of the peanut butter jars from the pile around me and twisted off the lid. This time, there was no puff of smoke. But what if Ridge was trapped beneath that papery protective seal? I jabbed my index finger through, feeling it sink in creamy peanut butter up to the second knuckle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I dropped the jar and grabbed another, repeating the process. The second one was not a genie, either. It was chunky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A short distance away, I saw a bit of rubble rousing. Ms. Gomez! She pushed aside a broken shelf and painstakingly rose to her knees. Her black hair looked gray with dust, and her movements were slow but determined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ms. Gomez looked up at Robo Rex defiantly. Its animatronic eyes fixed on her and I thought I saw the tiny laser arms recharging.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("“Hey!” I shouted, leaping to my feet and hurling the ordinary jar of peanut butter at the robot dinosaur. It pinged harmlessly off one of the metal legs. “Pick on someone your own size!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In response, Robo Rex turned its gaze on me, pointing the lasers in my direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not me!” I shouted, backing up. “I’m way smaller than you!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ms. Gomez looked at me as I tripped on the array of peanut butter jars and fell hard on my backside. “Adios, muchacho!” she said, sprinting toward the store’s exit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going to help me?” I screamed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("I")]), _vm._v(" didn’t break the necklace!” I heard her shout as she ducked out of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I managed to stick my fingers into three more jars of peanut butter before the dino’s lasers powered up again. It fired and the floor in front of me broke apart, debris flying with a cloud of smoke and the smell of toasted bread. Well, at least Robo Rex had terrible aim.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the sound of grinding gears, it came toward me. I scrambled away from the pile of peanut butter jars, grabbing two on my way out. I was counting on one of them to house Ridge, because the mechanical dinosaur’s foot promptly pulverized the rest of the pile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That giant stomper came down right where I’d been sitting. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("I heard the plastic jars popping like grapes under its metal foot. Peanut butter spattered everywhere. I felt a big gob of it hit me square in the back as I staggered away.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cleanup on aisle twelve!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sprinted around the end of the shelf and ran down two more aisles before making a brief stop next to the spices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay, jar number one. Please have a genie inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tucking one jar under my arm, I quickly twisted the lid off the other. I stabbed my finger through the quality seal and came up with nothing but sticky spread.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grunting in anger, I tossed the useless jar aside. Behind me, I heard the giant robot dinosaur smashing through shelves, coming my way. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay, jar number two. It had better be you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I slipped it out from under my arm, grabbed the lid, and gave it a sharp twist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing but peanut butter. Organic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hurled it down the aisle. Now my only hope was to circle back around to the scene of the peanut butter massacre and try to find Ridge’s jar in the mess. I might have stomped my feet in frustration if Robo Rex’s head hadn’t suddenly appeared over the spice shelf.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I dove forward, the light-up teeth snapped at the spot where I had been standing. I ran aimlessly, painfully aware that "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("I was moving away from the peanut butter squish and any hope of finding Ridge.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hmmm . . . How to stop a robot dinosaur without some magical assistance?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One time, a kid in my class ruined his remote-control car when he dropped it in the toilet. Not sure why he had it in the bathroom, but it was clear that electronics and water didn’t mix.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A laser blast went over my shoulder, striking the refrigerated dairy section and melting twenty pounds of butter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s it! Milk!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe I could short-circuit Robo Rex with a couple gallons of milk. At least that might slow it down so I could get back to the peanut butter aisle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grabbed two jugs of skim milk and turned to face the dinosaur. I really hoped this guy was lactose intolerant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I threw the first jug, hoping it would break open when it hit, but I missed altogether. Turned out I was just as bad at aiming as the T. rex. And I had full-sized arms!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My second jug got him right under the chin, breaking open and showering the robot. But instead of throwing sparks and slowing him down, the milk bath just seemed to enrage him. Robo Rex’s foot came up for a mighty stomp, higher than any one before. And then I saw it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Ridge’s genie jar.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The peanut butter container was lodged in the bottom of the dinosaur’s foot like a thorn. The metal was ripped and folded back, and I could just see the plastic lid sticking out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Any other container would have been smashed to bits, but a genie jar was unbreakable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I acted out of sheer impulse, leaping forward as the foot started to come down. Dropping to my knees, I slid across the wet, milky floor. My hands came up, scraping the cold metal and groping blindly. I caught the lid and felt the jar fall into my grasp, clearing the foot just as it came down to crack the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was on my feet, sprinting down the nearest aisle that still had shelves intact. Behind me, the dinosaur’s metal tail swiped around, utterly crushing the dairy section.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gasping for breath, I came to a halt. My fingers were still messy with peanut butter, and I slipped twice while trying to twist off the lid. At last, I felt it turn in my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a loud bang and a puff of smoke, and I felt the lid disintegrate in my grasp. I let out a victorious laugh, peering through the smoke to see my long-awaited genie friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Across the aisle, I thought I saw his silhouette, but his back was to me. And his voice . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Behold, mere mortal!” cried a gravelly voice. “I stand between you and the power of the Universe. Your wish is my "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("command. But beware the costly consequences that come with . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The smoke cleared and the genie turned around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, hey, Ace! It’s you!” It was indeed Ridge, and now his voice had returned to the squeaky timbre I was familiar with. “You’re my Wishmaker? What are the odds that the Universe would put us together again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Universe didn’t,” I said. “It was a trinket. And what happened to your voice a second ago?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, that.” Ridge scratched self-consciously at his curly hair. “I was trying something new. You see, when I appeared to you the first time, I didn’t do a really great job of explaining anything. I figured I should lay down some of the basics for my new Wishmaker. Maybe try out a more intense voice to get some respect.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It sounded like you had a cold,” I pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was going for ominous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was a bright flash of lasers and the shelf behind Ridge exploded. He screamed good and loud, but I was past that by now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What was that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the robot T. rex,” I explained. “He’s got laser arms.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why is there a robot T. rex in the grocery store?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um . . . I blame Tina’s mom.” I could tell the dinosaur was "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("making its way toward us, demolishing anything in its path. It was wishing time. I held out my arm, waggling my wrist at him. “Don’t you have something for me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right!” Ridge fumbled for a moment before slapping a familiar wristwatch onto my arm. I glanced down at the leather band and smooth face. Hello, old friend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robo Rex finally rounded the corner and Ridge got his first glimpse of our enemy. He squealed and turned to run, but I grabbed his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We run, Ace!” Ridge said. “That’s what sensible people do when robot dinosaurs are chasing them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We fight,” I rebutted. “That’s what a Wishmaker does. This thing’s purpose is to destroy. If we don’t shut it down, there’s no telling how much of this town it’ll ruin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A laser blast went over our heads. “Okay,” I muttered under my breath, rubbing my hands together and shutting my eyes in concentration. “Wish smart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My obvious first thought was to wish that Robo Rex would deactivate or fall apart. But that was a direct wish—one that wouldn’t require much work from me. During my last quest, I had learned that those direct wishes gave me more intense consequences. Easier consequences came from wishes that still required me to do something.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s charging up his bazooka tail!” Ridge shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("I cracked my eyes open in time to see the dinosaur’s metal tail swing sideways to scatter an aisle display. “He doesn’t have a bazooka tail,” I replied.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know that!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("True. I didn’t. Maybe Robo Rex was saving the best for last. No matter the case, I didn’t want to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wish I had metal boxing gloves strong enough to knock this guy out!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was my first time wishing in nearly two weeks. The words felt good as they rolled off my tongue. I heard a click and glanced down at my wrist. A magical hourglass had emerged from the face of my watch, standing tall, familiar white sand showing me exactly how much time I had to consider and accept the accompanying consequence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s good to be back!” Ridge shouted, clapping his hands. “If you want metal boxing gloves”—he glanced warily at the slowly approaching dinosaur—“then you’ll have to tiptoe everywhere you go for the rest of the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s not so bad,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Might even be helpful,” Ridge said. “Maybe the T. rex won’t hear you coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had plenty of time left in my hourglass watch but significantly less time before Robo Rex reached us. Boxing a T. rex couldn’t be too bad. His lasers were still recharging, and it "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("wasn’t like he could punch back with those tiny arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll take it!” I shouted. But the Universe required me to say the magic word before my wish would be granted. “Bazang!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The peanut butter jar slipped from my grasp as two large metal boxing gloves formed around my fists. Oh, man, this was going to be awesome. I was going to leap off the shelves and come soaring down with a jaw-shattering superhero punch. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I instantly fell to the floor, pulled down by the incredible weights around my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get up!” Ridge shouted, holding his own jar and cowering against the cornmeal. “Get up and punch!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t!” I had risen to a crouch on my tiptoes. Both my fists were against the floor as I strained against my new mitts. “The gloves are too heavy! Give me a hand!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ridge moaned in fear, coming to my side and grabbing my forearm. We heaved together and my right boxing glove lifted about an inch off the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you should wish for more muscles,” Ridge said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we should run!” How fast could I move on my tiptoes?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robo Rex was upon us. I slipped my hands out of the metal gloves and jumped back. At the same moment, I saw the dinosaur’s lights flicker. The mechanical whirr of its moving parts seemed to slow. Its massive head drooped, and its tiny laser arms powered down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("Then Robo Rex fell uselessly sideways, crashing through a shelf in a tremendous puff of dust and baking flour.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Woohoo!” Ridge cried, turning to give me a high five. “We did it!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared in confusion at the fallen destruction machine. “We didn’t do anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think we scared it to death,” Ridge said. “You know how T. rexes are. Challenge them to a boxing match and they fall right over. Big scaredy-cats . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s someone over there,” I muttered, peering through the white cloud of flour and dust. A figure was standing atop the crumpled form of the dinosaur. As I watched, he slid down the metal sheeting of the T. rex’s side and landed in the aisle in front of Ridge and me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now that I could see him clearly, my eyes went wide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jathon?”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9e6f48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062568366_Chapter_2.vue
// module id = 69
// module chunks = 0